import { render, staticRenderFns } from "./SmCardConsultationUpdate.vue?vue&type=template&id=46b45352&"
import script from "./SmCardConsultationUpdate.vue?vue&type=script&lang=ts&"
export * from "./SmCardConsultationUpdate.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports